import { render, staticRenderFns } from "./unidentified-object.vue?vue&type=template&id=6bee4700&scoped=true&"
import script from "./unidentified-object.vue?vue&type=script&lang=ts&"
export * from "./unidentified-object.vue?vue&type=script&lang=ts&"
import style0 from "./unidentified-object.vue?vue&type=style&index=0&id=6bee4700&prod&lang=scss&scoped=true&"
import style1 from "./unidentified-object.vue?vue&type=style&index=1&id=6bee4700&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bee4700",
  null
  
)

export default component.exports